import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const indicatorOptions = [
  { value: 'sma', label: 'SMA' },
  { value: 'ema', label: 'EMA' },
  { value: 'rsi', label: 'RSI' },
  { value: 'atr', label: 'ATR' },
  { value: 'macd', label: 'MACD' },
  { value: 'vwap', label: 'VWAP' },
  { value: 'adx', label: 'ADX' },
  { value: 'cci', label: 'CCI' },
  { value: 'williams_r', label: 'Williams %R' },
  { value: 'roc', label: 'ROC' },
  { value: 'momentum', label: 'Momentum' },
  { value: 'trix', label: 'TRIX' },
  { value: 'vortex', label: 'Vortex' },
  { value: 'dpo', label: 'DPO' },
];

export default function TimeframeNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #7c3aed',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#a78bfa' }}>
        📅 Timeframe
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
        <select
          value={data.timeframe || '1day'}
          onChange={(e) => onChange('timeframe', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="1hour">1 Hour</option>
          <option value="2hour">2 Hour</option>
          <option value="4hour">4 Hour</option>
          <option value="1day">1 Day</option>
          <option value="1week">1 Week</option>
          <option value="1month">1 Month</option>
        </select>
        <input
          type="number"
          min={1}
          value={data.params?.period ?? 200}
          onChange={(e) => onChange('params', { ...data.params, period: Math.max(1, parseInt(e.target.value, 10) || 1) })}
          style={{ width: 74, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      <select
        value={data.indicator || 'sma'}
        onChange={(e) => onChange('indicator', e.target.value)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        {indicatorOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#7c3aed' }} />
    </div>
  );
}
